import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'del',
  'ul',
  'ol',
  'li',
  'a',
  'h1',
  'h2',
  'h3',
  'h4',
  'blockquote',
  'span',
];

const ALLOWED_ATTR = ['href', 'target', 'rel', 'style'];

/**
 * Sanitizes an HTML string produced by the rich text editor before rendering it
 * with dangerouslySetInnerHTML. Removes scripts, event handlers and any tags/
 * attributes that are not part of the editor whitelist.
 */
export const sanitizeHtml = (html: string): string => {
  if (!html) {
    return '';
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Force safe links: no javascript: URIs, external links open safely.
    ADD_ATTR: ['target'],
  });
};

/**
 * Returns the plain text content of an HTML string. Used for search matching
 * and for measuring the effective length of a rich-text description.
 */
export const stripHtml = (html: string): string => {
  if (!html) {
    return '';
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
};
